// Generated by ReScript, PLEASE EDIT WITH CARE

import Classnames from "classnames";
import * as JsxRuntime from "react/jsx-runtime";
import * as BsCssJs$PrezzeeRibbon from "../../../bindings/BsCss/BsCssJs.bs.js";
import * as ThemeContext$PrezzeeRibbon from "../../../context/ThemeContext/ThemeContext.bs.js";

function themeStyles(theme) {
  var match = theme.components;
  return BsCssJs$PrezzeeRibbon.style([BsCssJs$PrezzeeRibbon.color(match.tagline.color)]);
}

var tagline = BsCssJs$PrezzeeRibbon.style([
      BsCssJs$PrezzeeRibbon.textTransform("uppercase"),
      BsCssJs$PrezzeeRibbon.fontSize(BsCssJs$PrezzeeRibbon.px(12)),
      BsCssJs$PrezzeeRibbon.lineHeight(BsCssJs$PrezzeeRibbon.px(24)),
      BsCssJs$PrezzeeRibbon.letterSpacing(BsCssJs$PrezzeeRibbon.em(0.04)),
      BsCssJs$PrezzeeRibbon.marginBottom(BsCssJs$PrezzeeRibbon.px(2))
    ]);

var Styles = {
  themeStyles: themeStyles,
  tagline: tagline
};

function Tagline(props) {
  var className = props.className;
  var className$1 = className !== undefined ? className : "";
  var theme = ThemeContext$PrezzeeRibbon.useTheme(undefined);
  return JsxRuntime.jsx("div", {
              children: props.children,
              className: Classnames([
                    tagline,
                    themeStyles(theme),
                    className$1
                  ])
            });
}

var make = Tagline;

export {
  Styles ,
  make ,
}
/* tagline Not a pure module */
